import 'css-chunksrc/client/pages/calendarPage/sideBar/export/styles.scss';export default {
  "export": "_export_1trpv_1",
  "exportButton": "_exportButton_1trpv_6",
  "group": "_group_1trpv_12",
  "title": "_title_1trpv_16",
  "exportLink": "_exportLink_1trpv_22",
  "link": "_link_1trpv_34",
  "copyButton": "_copyButton_1trpv_43",
  "copyIcon": "_copyIcon_1trpv_52"
};